import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DNAAlertSlideDown from 'dna-alert/components/alert/AlertSlideDown.jsx';

export default class AlertRecoverableError extends Component {
	static propTypes = {
		intl: PropTypes.object.isRequired,
		isRecoverableError: PropTypes.oneOfType([
			PropTypes.bool,
			PropTypes.string,
			PropTypes.object
		]),
		networkStatus: PropTypes.string,
		decoratorClass: PropTypes.string,
	};
	getAlertMessage() {
		const {
			isRecoverableError,
			networkStatus,
			intl,
		} = this.props;

		const isRecoverableErrorType = typeof isRecoverableError;
		const alertMessage = isRecoverableErrorType.match(/string|object/) ? isRecoverableError : 'recoverable' ;

		if (typeof alertMessage === 'object' && alertMessage.link) {
			return (
				<span>
					{intl.formatMessage(`err:${alertMessage.intlKey}`)}
					{alertMessage.link()}
				</span>
			);
		} else {
			return intl.formatMessage(`err:${alertMessage}`);
		}
	}
	render() {
		const {
			decoratorClass,
			isRecoverableError,
		} = this.props;

		return (
			<DNAAlertSlideDown
				renderAlert={isRecoverableError ? true : false}
				id='isRecoverableError'
				decoratorClass={decoratorClass}
				alertType='amber'
				alertMessage={::this.getAlertMessage()}
				qaSelector='alertRecoverableError' />
		);
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/components/alert/AlertRecoverableError.js